import { Box, Divider, Stack, Tab, Tabs, Typography } from '@mui/material'
import { formatCurrency } from 'utils/formatCurrency'

export type InventoryV3ViewMode = 'active' | 'sold' | 'pending' | 'ready'

export interface InventoryV3Totals {
  count: number
  listPrice: number
  purchasePrice: number
  profit: number
}

interface InventoryV3FooterProps {
  viewMode: InventoryV3ViewMode
  onChangeViewMode: (mode: InventoryV3ViewMode) => void
  totals: InventoryV3Totals
  selectionActive?: boolean
  canViewPurchasePrice: boolean
  canViewProfit: boolean
}

const Total = ({ label, value }: { label: string; value: string }) => (
  <Stack direction='row' spacing={0.75} alignItems='baseline'>
    <Typography variant='caption' color='text.secondary'>
      {label}
    </Typography>
    <Typography variant='body2' fontWeight={600}>
      {value}
    </Typography>
  </Stack>
)

export const InventoryV3Footer = ({
  viewMode,
  onChangeViewMode,
  totals,
  selectionActive = false,
  canViewPurchasePrice,
  canViewProfit,
}: InventoryV3FooterProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 1,
      px: 1.5,
      borderTop: 1,
      borderColor: 'divider',
      backgroundColor: 'background.paper',
    }}
  >
    <Tabs
      value={viewMode}
      onChange={(_event, value: InventoryV3ViewMode) => onChangeViewMode(value)}
      variant='scrollable'
      scrollButtons='auto'
      sx={{ minHeight: 40, '& .MuiTab-root': { minHeight: 40, py: 0 } }}
    >
      <Tab value='active' label='Active' />
      <Tab value='sold' label='Sold' />
      <Tab value='pending' label='Pending' />
      <Tab value='ready' label='Ready' />
    </Tabs>

    <Stack
      direction='row'
      spacing={2}
      alignItems='center'
      divider={<Divider orientation='vertical' flexItem />}
      sx={{ py: 1 }}
    >
      <Total
        label={selectionActive ? 'Selected' : 'Trucks'}
        value={new Intl.NumberFormat('en-US').format(totals.count)}
      />
      <Total label='List' value={formatCurrency(totals.listPrice)} />
      {canViewPurchasePrice && <Total label='Purchase' value={formatCurrency(totals.purchasePrice)} />}
      {canViewProfit && <Total label='Profit' value={formatCurrency(totals.profit)} />}
    </Stack>
  </Box>
)
